import React from 'react';

const ProgressCircle = ({ percentage, title, showApplication, status, onClick, isActive = false }) => {
    const circumference = 2 * Math.PI * 45;
    const strokeDasharray = circumference;
    const strokeDashoffset = circumference - (percentage / 100) * circumference;

    const getStatusColor = () => {
        if (isActive) return 'text-custom-green-1';
        if (status === 'completed') return 'text-custom-green-1';
        if (status === 'in-progress') return 'text-orange-600';
        return 'text-white';
    };

    const getCircleColor = () => {
        if (isActive) return 'stroke-custom-green-1';
        if (status === 'completed') return 'stroke-custom-green-1';
        if (status === 'in-progress') return 'stroke-orange-600';
        return 'stroke-white';
    };

    return (
        <div
            className={`flex flex-col items-center p-2 sm:p-4 rounded-lg min-w-[100px] sm:min-w-[120px] ${onClick ? 'cursor-pointer hover:scale-105 hover:bg-white/10 hover:shadow-lg transition-all duration-300 group' : ''}`}
            onClick={onClick}
        >
            <div className="relative w-16 h-16 sm:w-24 sm:h-24 mb-2 sm:mb-4">
                <svg className="w-16 h-16 sm:w-24 sm:h-24 transform -rotate-90" viewBox="0 0 100 100">
                    <circle
                        cx="50"
                        cy="50"
                        r="45"
                        stroke="currentColor"
                        strokeWidth="8"
                        fill="transparent"
                        className="text-white/20"
                    />
                    <circle
                        cx="50"
                        cy="50"
                        r="45"
                        stroke="currentColor"
                        strokeWidth="8"
                        fill="transparent"
                        strokeDasharray={strokeDasharray}
                        strokeDashoffset={strokeDashoffset}
                        className={`transition-all duration-1000 ease-out ${getCircleColor()} ${onClick ? 'group-hover:brightness-110' : ''}`}
                        strokeLinecap="round"
                    />
                </svg>
                <div className="absolute inset-0 flex items-center justify-center">
                    <span className={`text-sm sm:text-xl font-bold ${getStatusColor()} ${onClick ? 'group-hover:scale-110 transition-transform duration-200' : ''}`}>
                        {percentage}%
                    </span>
                </div>
                {/* Click indicator icon */}
                {onClick && (
                    <div className="absolute -bottom-1 -right-1 w-4 h-4 sm:w-6 sm:h-6 bg-custom-green-1 rounded-full flex items-center justify-center opacity-70 group-hover:opacity-100 transition-opacity duration-200">
                        <svg className="w-2 h-2 sm:w-3 sm:h-3 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                        </svg>
                    </div>
                )}
            </div>
            <h3 className={`text-xs sm:text-sm font-medium text-white/90 text-center ${onClick ? 'group-hover:text-white transition-colors duration-200' : ''}`}>{title}</h3>
            {onClick && (
                <p className="text-xs text-white/60 group-hover:text-white/80 text-center mt-1 transition-colors duration-200 hidden sm:block">
                    Click to view details
                </p>
            )}
        </div>
    );
};

export default ProgressCircle;